import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=74dfc002&scoped=true&"
import script from "./Recycle.vue?vue&type=script&lang=js&"
export * from "./Recycle.vue?vue&type=script&lang=js&"
import style0 from "./Recycle.vue?vue&type=style&index=0&id=74dfc002&prod&lang=css&"
import style1 from "./Recycle.vue?vue&type=style&index=1&id=74dfc002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfc002",
  null
  
)

export default component.exports